import React from 'react';
import { MenuItemWithAnalytics } from '@atlassian/learning-components';
import { css } from '@compiled/react';
import { token } from '@atlaskit/tokens';

import { withUrlPrefix, LINKS } from './GlobalAppNavigation';

export const AdoptionMobileMenu: React.FC = () => (
  <ul css={listStyles}>
    <MenuItemWithAnalytics link={withUrlPrefix(LINKS.ROVO)} type="subMenu" />
  </ul>
);

const listStyles = css({
  display: 'flex',
  flexDirection: 'column',
  gap: token('space.150'),
  listStyle: 'none',
  margin: 0,
  padding: `${token('space.150')} 0 0 0`,

  '&:hover li': {
    color: token('color.link'),
  },

  li: {
    padding: `${token('space.200')} 0`,
  },
});
